import { deleteDataV2, getDataByApi, copyTreeData, saveData, batchSaveData } from '@/api/form-render';
import {mapGetters, mapMutations} from 'vuex';
export const gridMixin = {
  data: function () {
    return {
      showRowEditButton: true,
      showRowDeleteButton: true,
      showOpenDialogTitle: false,
      openDialogConfirmVisible: false, // 弹框打开表单是否显示确认取消按钮
      openDialogTitle: '', // 弹框打开表单的标题
      openDialogConfig: {}, // 弹框打开表单的配置
      openDialogVueName: '', // 弹框打开表单的配置
      openDialogVisible: false, // 弹框打开页面openType=1
      editButtonColumn:null,
      summaryColumns: {}, // 合计列
      summaryData: {}, // 表格合计数据
      showSummary: false, // 是否显示合计
      showPageBar: true, // 显示分页条
      columnTitleMap: {}, // 存储标题跟字段的对应关系
      columnsMap: {}, // 存储所有列
      // singleSelect:false, // 是否单选
      // multiSelect:false, // 是否多选
      defaultPic: require('../../assets/img/defaut.jpg'),
      emptyText: '',
      dicMap: {},
      topButtons: [], // 顶部工具栏
      selection: [], // 复选框数据
      searchVisible: false, // 是否显示搜索框
      formConfig: {}, // 对应的表单的配置
      queryFormVisible: false,
      keyword: false,
      formData: [], // 高级查询对应的表单中数据
      selectedData: [], // 记录累计选中行，常用于分页复选框
      searchFormRows: [],
      formDialogVisible: false,
      loading: false,
      searchFormColumns: [],
      selectMemberModels: {// 人员控件
        form: {},
        isShow: false,
        selectList: [],
        callBack: this.memberCallBack,
        radioSelectFlags: false
      },
      selectRoleModels: {// 角色控件
        isShow: false,
        selectList: [],
        callBack: this.selectRoleCallBack,
        radioSelectFlags: false
      },
      selectQuertersModels: {// 部门控件
        isShow: false,
        form: {},
        selectList: [],
        callBack: this.quertersCallBack,
        radioSelectFlags: false
      }
    };
  },
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      }
    },
    level: { // 层级
      type: Number,
      default: function () {
        return 1;
      }
    },
    readOnly: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    multipleSelect: { // 多选
      type: Boolean,
      default: false
    },
    hasTitle: { // 是否有标题
      type: Boolean,
      default: true
    },
    hasQuery: { // 是否显示查询
      type: Boolean,
      default: true
    },
    queryParams: {
      type: Object,
      default: function () {
        return {};
      }
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    isTree: {
      type: Boolean,
      default: false
    },
    cascade: { // 是否级联
      type: Boolean,
      default: false
    },
    autoLoad: { // 自动加载
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'getFormConfig'
    ]),
    formDialogStyle () { // 打开表单的样式
      // 判断如果是左边的话还是弹框
      if (this.isLeft) {
        return {
          width: this.formConfig.formWidth ? (this.formConfig.formWidth.indexOf('px') > -1 ? this.formConfig.formWidth : this.formConfig.formWidth + 'px') : '900px',
          height: this.formConfig.formHeight ? (this.formConfig.formHeight.indexOf('px') > -1 ? this.formConfig.formHeight : this.formConfig.formHeight + 'px') : '600px'
        };
      } else {
        return {width: '100%', height: '100%', position: 'absolute', zIndex: '12', top: '0', background: 'white', 'padding-left': '10px', 'padding-right': '10px', 'box-sizing': 'border-box', 'padding-top': '10px'};
      }
    },
    dicValue () { // 数据字典label
      return function (column, value) {
        // console.info(this.dicMap[column.columnName])
        if (column) {
          if (this.dicMap[column.columnName]) {
            if (this.validUtil.isNotNull(value)) {
              return this.dicMap[column.columnName][value];
            } else {
              return this.dicMap[column.columnName][''];
            }
          }
        }
        return value || '';
      };
    },
    formatDate () {
      return function (column, row) {
        // console.log('-----formatDate-----')
        let format = 'yyyy-MM-dd';
        if (column.widgetType === 'select-time') {
          format = 'HH:mm:ss';
        } else if (column.widgetType === 'select-date-time') {
          format = 'yyyy-MM-dd hh:mm:ss';
        }
        if (row[column.columnName + 'LABEL_']) {
          return row[column.columnName + 'LABEL_'];
        } else {
          // console.info(format+'---'+row[column.columnName]+'---'+typeof row[column.columnName]+'----'+column.columnName)
          if (typeof row[column.columnName] === 'number') {
            let date = new Date(row[column.columnName]);
            // console.info('-----------'+date.format('yyyy-MM-dd'))
            return date.format(format);
          } else if (typeof row[column.columnName] === 'string') {
            if (row[column.columnName].indexOf('T') > -1) {
              return row[column.columnName].substring(0, 10);
            } else {
              try {
                let date = new Date(row[column.columnName]);
                return date.format(format);
              } catch (e) {
                return row[column.columnName];
              }
            }
          }
        }
      };
    },
    computePicView () {
      return function (column, row) {
        let defaultUrl = this.defaultPic;// 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
        if (row[column.columnName]) {
          defaultUrl = this.util.getBaseUrl() + '/api_v1/files/' + row[column.columnName] + '/look?ifThumb=' + column.ifThumb + '&access_token=' + this.sessionUtil.getAccessToken();
        }
        return defaultUrl;
      };
    },
    columnDisabled () {
      return function (column, row) {
        // console.log(column.title+'---------------'+column.disabledCondition,row)
        if (this.validUtil.isNotNull(column.disabledCondition)) {
          return this.computeDisabledConditionConfig(column, row);
        }
        return false;
      };
    }
  },
  watch: {
    dicMap: {
      handler: function (val, oldval) {
        // console.log('------dicMap--------')
        // console.info(JSON.stringify(val))
      },
      deep: true// 对象内部的属性监听，也叫深度监听
    },
    selection: {
      handler: function (val, oldval) {
        // console.log(oldval,'---watch---selection--------',val)
      }
    }
  },
  mounted () {

  },
  created () {
    this.util.init(this);
    this.topButtons = [];
  },

  methods: {
    closeForm () {
      this.formDialogVisible = false;
      // 弹框的关闭和保存之后调用关闭
      this.openDialogVisible = false;
    },
    closeOpenDialog () {
      this.openDialogVisible = false;
    },
    handlerFormOpen (column) { // 点击新增或编辑按钮\
      if (this.$route.params.formKey) { delete this.$route.params.formKey; }
      // console.info(this.config)

      // 左右级联打开表单时自动填写选中的树节点的id和title填充到表单中，默认规则为：PARENT_ID_ = ID_,PARENT_ID_LABEL_ = TITLE_
      let parentSelectedRow = this.parentSelectedRow; // 先从右侧获取，
      // console.log('----handlerFormOpen--1--', parentSelectedRow)

      let initValues = { ...this.queryParams };
      if (this.gridData) {
        initValues['SORT_'] = this.gridData.length + 1;
      } else {
        initValues['SORT_'] = 1;
      }
      // 获取选中的节点
      let selectedNode = null;

      // 判断是否是树
      if (this.isTreeCmp()) {
        let parentColumnName = this.config.parentColumn;
        let parentColumnLabel = this.config.parentColumn + 'LABEL_';
        // 获取选中的节点
        let selectedNode = null;
        let selectedData = this.getSelectedData(0);
        if (selectedData && selectedData.length > 0) {
          selectedNode = selectedData[0];
        }
        if (selectedNode !== undefined && selectedNode != null) {
          // 判断如果是树，则获取选中的树节点
          let selectedTreeNode = this.$refs['jr-table'].getNode(selectedNode.id);
          // console.log(selectedNode.parentId + '----parent----', selectedTreeNode.parent)
          // console.log('----selectedTreeNode----', selectedTreeNode)
          // 默认是同级新增，判断是否新增下级
          if (column && column.columnName === 'new-child') {
            initValues['SORT_'] = selectedTreeNode.childNodes.length + 1;
          } else {
            // 同级新增
            initValues['SORT_'] = selectedTreeNode.parent.childNodes.length + 1;
            if (selectedNode.parentId === this.config.rootId) {
              selectedNode = {
                id: selectedNode.parentId,
                ID_: selectedNode.parentId,
                TITLE_: this.config.rootText
              };
            } else {
              selectedNode = selectedTreeNode.parent.data;
            }
          }
          initValues[parentColumnName] = selectedNode['ID_'];
          initValues[parentColumnLabel] = selectedNode[this.config.treeColumn] ? selectedNode[this.config.treeColumn] : (selectedNode['TITLE_'] ? selectedNode['TITLE_'] : (selectedNode['NAME_'] ? selectedNode['NAME_'] : selectedNode['PROJ_NAME_']));
        } else {
          // 默认是在root根节点下面增加子节点

          this.info('您未选中任何节点，将在根节点下添加！');
          initValues[parentColumnName] = this.config.rootId;
          initValues[parentColumnLabel] = this.config.rootText;
          let rootNode = this.getSelectedTreeNode(this.config.rootId);
          if (rootNode && rootNode !== null) {
            initValues['SORT_'] = rootNode.childNodes.length + 1;
          } else {
            initValues['SORT_'] = this.gridData.length + 1;
          }
        }
      } else if (this.isTreeGridCmp()) {
        // 判断是否是树表
        let parentColumnName = this.config.parentColumn;
        let parentColumnLabel = this.config.parentColumn + 'LABEL_';
        let selectedData = this.getSelectedData(0);
        if (selectedData && selectedData.length > 0) {
          selectedNode = selectedData[0];
        }
        let code = '';
        let sort = 0;
        let children = null;
        // console.log('-----isTreeGridCmp-----', selectedNode)
        if (selectedNode !== undefined && selectedNode != null) {
          // 默认是增加下级
          initValues['SORT_'] = selectedNode.children ? selectedNode.children.length + 1 : 1;
          sort = initValues['SORT_'];
          // console.log('-------this.queryParams-------', initValues, selectedNode)
          initValues[parentColumnName] = selectedNode['ID_'];
          initValues[parentColumnLabel] = selectedNode[this.config.treeColumn] ? selectedNode[this.config.treeColumn] : (selectedNode['TITLE_'] ? selectedNode['TITLE_'] : (selectedNode['NAME_'] ? selectedNode['NAME_'] : selectedNode['PROJ_NAME_']));
          // 默认编号
          code = selectedNode['CODE_'];
          children = selectedNode.children;
        } else {
          // 默认是在root根节点下面增加子节点
          initValues[parentColumnName] = this.config.rootId;
          initValues[parentColumnLabel] = this.config.rootText;
          // 添加跟节点显示
          if (this.config.showRoot && !this.rootId) {
            sort = this.gridData.length>0?this.gridData[0].children.length+1:1;
            children = this.gridData.length>0?this.gridData[0].children:[];
          }else{
            sort = this.gridData.length+1;
            children = this.gridData;
          }

        }
        // console.log(code+'---------',children);
        if(code !== undefined){
          if(children == null || children.length == 0){
            code = code + this.util.prefixInteger(sort,2);
          }else{
            while(true){
              let newCode = code + this.util.prefixInteger(sort++,2);
              // console.log(newCode+'-------------'+sort);
              // 查找是否子节点中已经有了
              let find  = children.find(c=>{
                return c['CODE_'] === newCode;
              });
              // console.log('---find---',find);
              if(find){

              }else{
                code = newCode;
                break;
              }
            }
          }

        }
        // console.log(sort+'-----code-----'+code,this.gridData);
        initValues['CODE_'] = code;
      }

      // 判断是左右结构左侧添加，还是单页面添加
      if (this.level === 1) {

      } else if (this.level > 1) {
        // 说明是左右结构或者上下结构，右侧添加
        // 获取左侧选中数据
        let parentSelectedData = this.parentSelectedRow ? [this.parentSelectedRow] : this.config.parent.getSelectedData(this.level - 1);
        // console.log('--------左右结构右侧添加-------', parentSelectedData)
        if (parentSelectedData === undefined || parentSelectedData === null || parentSelectedData.length === 0) {
          this.warn('请选择关联数据！');
          return;
        }
        parentSelectedData = parentSelectedData[0];
        this.formConfig.parentSelectedData = parentSelectedData;
        // 左右结构组装数据
        let columnName = 'PARENT_ID_';
        let columnLable = 'PARENT_ID_LABEL_';
        if (this.config && this.config.parent && this.config.parent.formConfig && this.config.parent.formConfig.linkColumnName) {
          columnName = this.config.parent.formConfig.linkColumnName;
          columnLable = this.config.parent.formConfig.linkColumnName + 'LABEL_';
        }
        // debugger
        // 判断是否是树结构，且树parentColumn和关联列一样，比如数据字典管理左右结构
        if (this.config.parentColumn && this.config.parentColumn == columnName && selectedNode != null) {
          // 如果右侧已经有选中的节点，在之前已经赋值过上级目录了
        } else {
          initValues[columnName] = parentSelectedData['ID_'];
          initValues[columnLable] = parentSelectedData['TITLE_'] || parentSelectedData['NAME_'] || parentSelectedData['PROJ_NAME_'] || parentSelectedData['DIC_NAME_'] || parentSelectedData['SUBJECT_'];
        }
      }

      this.formConfig.initValues = initValues;
      // console.log('------this.config--------', this.config)
      // 判断form-view中的路由qeury是否有值
      let routeQuery = this.config.parent.routeQuery;
      if (routeQuery && routeQuery !== undefined && routeQuery != null) {
        if (this.formConfig.initValues === undefined) {
          this.formConfig.initValues = routeQuery;
        } else {
          if (this.formConfig.initValues === undefined || this.formConfig.initValues === null) {
            this.formConfig.initValues = {};
          }
          for (let key in routeQuery) {
            this.formConfig.initValues[key] = routeQuery[key];
          }
          // this.formConfig.initValues = this.formConfig.initValues.concat(routeQuery);
        }
      }
      // console.log('------this.formConfig.initValues--------', this.formConfig.initValues)
      // console.info(this.formConfig,'sss')
      this.formConfig.parent = this;
      this.formConfig.businessKey = '';
      // this.formConfig.sort =
      this.formDialogVisible = true;
    },
    iptBlur (row, column, index) {
      // this.clickRow = row;
      setTimeout(() => {
        this.$set(row, column.columnName + 'isShow', false);
      }, 100);
    },
    cellClick (index, row, column, scope) {
      if(this.validUtil.isNotNull(column.disabledCondition)){
        let disabled = this.computeDisabledConditionConfig(column,row);
        // console.log('----disabled----',disabled);
        if(disabled){
          this.util.warn("对不起，您没有权限!");
          return;
        }
      }
      // console.log('-------cellClick---------',index, column,row,this.readOnly,scope)
      // 判断是否需要可编辑
      if (!this.singleSelect && !this.multipleSelect && !this.readOnly && (column.readOnly !== undefined && column.readOnly === 0) && (column.widgetType && column.widgetType === 'input')) {
        this.$set(row, column.columnName + 'isShow', true);
        this.$forceUpdate();
        // console.log(row[column.columnName + 'isShow']+'---------------',row)
        // row[column.columnName + 'isShow'] = true
        if (!column.widgetType || (column.widgetType && column.widgetType != 'date')) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.$refs[column.columnName + index][0].focus();
            });
          }, 100);
        }
      }

      // 触发单击整行事件
      this.rowClick(row);
      // 只读点击无效
      /* if (this.readOnly) {
        return
      } */
      // console.log(row,column)
      if (column.openUrl && column.openParams) {
        // var openParams =  JSON.parse(column.openParams)
        // openParams.params = row
        // this.$router.push({
        //   name: column.openUrl,
        //   params: openParams
        // })
        // // this.$router.go(0)
        // this.util.routerRefresh()
        this.handleRowButtonClick(column, index, row);
      }
    },
    // 选中父亲
    checkParent (data, value) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === value.id) {
          return [data[i]];
        }
        if (data[i].children) {
          var ro = this.checkParent(data[i].children, value);
          if (ro !== undefined) {
            return ro.concat(data[i]);
          }
        }
      }
    },
    // 选择子类
    checkChildren (data) {
      for (let index = 0; index < data.length; index++) {
        this.$refs['jr-table'].toggleRowSelection(data[index]);
        if (data[index].children && data[index].children.length > 0) {
          this.checkChildren(data[index].children);
        }
      }
    },
    swapItems (arr, index1, index2) { // 交换数组元素位置
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    // 获取父亲
    getParent (data, value) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === value.id) {
          return [data[i]];
        }
        if (data[i].children) {
          this.getParent(data[i].children, value);
        }
      }
    },
    getParentNode (data, parentId) { // 递归父节点
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (item['id'] === parentId) {
            return item;
          }
          if (item['children']) {
            let node = this.getParentNode(item['children'], parentId);
            if (node) {
              return node;
            }
          }
        }
      }
      return undefined;
    },
    handlerTreeChangeValue (row) {
      if (!this.summaryColumns || !this.gridColumns || this.gridColumns.length === 0) {
        return;
      }
      row.id = row.ID_;
      row.parentId = row.PARENT_ID_;
      this.gridColumns.forEach(column => {
        let columnName = column.columnName;
        let columnConfig = this.summaryColumns[columnName];
        if (columnConfig) {
          this.handlerChangeValue(row[columnName], column, row, 0);
        }
      });
      console.log(row, 'rowwwww');
    },
    handlerChangeValue (newVal, column, row, index) {
      // 判断如果是树表，且有合计，则要向上统计
      if (this.isTreeGridCmp()) {
        let columnName = column.columnName;
        let columnConfig = this.summaryColumns[columnName];
        let updateData = [];
        if (columnConfig) {
          // 递归向上计算
          this.deepUpSummary(column, row, updateData);
          // console.log('------handlerChangeValue-------',updateData)
        } else {
          let mainFormDataMap = {};
          if (column.javaType && (column.javaType === 'Integer' || column.javaType === 'Double')) {
            newVal = Number(newVal);
            if (isNaN(newVal)) {
              newVal = 0;
            }
          }
          row[columnName] = newVal;
          mainFormDataMap[columnName] = newVal;
          updateData.push({
            id: row['ID_'],
            sqlTableName: this.config.tableName,
            mainFormDataMap: mainFormDataMap
          });
        }
        if (updateData.length > 0) {
          // 提交后台保存
          batchSaveData({
            formKey: this.config.formKey,
            formId: this.config.formId,
            formInfoId: this.config.id,
            batchData: updateData}).catch(e => {
            this.util.warn('修改数据失败，请刷新页面重试!');
          });
        }
      }
    },
    deepUpSummary (column, row, updateData) { // 递归向上合计
      let columnName = column.columnName;
      let value = Number(row[columnName]);
      if (isNaN(value)) {
        value = 0;
      }
      row[columnName] = value;
      let mainFormDataMap = {};
      mainFormDataMap[columnName] = value;
      updateData.push({
        id: row['ID_'],
        sqlTableName: this.config.tableName,
        mainFormDataMap: mainFormDataMap
      });
      // 如果父亲是根节点，则不需要统计，控件会自动计算
      if (row['parentId'] && row['parentId'] !== this.config.rootId) {
        let parentNode = this.getParentNode(this.gridData, row['parentId']);
        if (parentNode) {
          let summary = 0;
          const values = parentNode['children'].map(item => {
            let val = item[column.columnName];
            if (item.id === row.id) {
              val = row[column.columnName];
            }
            val = Number(val);
            return val;
          });
          if (!values.every(value => isNaN(value))) {
            // console.info('---------')
            let result = values.reduce((prev, curr) => {
              // console.info(prev+'--------'+curr)
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            summary = this.toFixed(result);
          } else {
            summary = 0;
          }
          parentNode[column.columnName] = summary;
          // console.log(column.columnName+'-------deepUpSummary---------',row, parentNode, summary)
          // 递归向上计算
          this.deepUpSummary(column, parentNode, updateData);
          this.$forceUpdate();
        }
      }
    },
    deepPackSummary(data){ // 树表loadData中，递归组装合计数据
      // console.log('----deepPackSummary----',this.summaryColumns,data );
      // 判断是否有合计
      if(this.summaryColumns && Object.keys(this.summaryColumns).length>0){
        data.forEach(item=>{
          this._deepPackSummary(item);
        });
      }
    },
    _deepPackSummary(item){
      let summary = {};
      if(item.children){
        item.children.forEach(c=>{
          this._deepPackSummary(c);
          for(let key in this.summaryColumns){
            if(summary[key] === undefined){
              summary[key] = 0;
            }
            summary[key] = summary[key] + Number(c[key]);
          }
        });
      }else{
        for(let key in this.summaryColumns){
         summary[key] = item[key];
        }
      }
      for(let key in this.summaryColumns){
        item[key] = summary[key]?this.toFixed (summary[key]):0;
      }

    },
    handleOperateClick (buttonId, index, row) { // 上移或下移
      let tableData = this.gridData;
      let length = tableData.length;
      // if(buttonId === 'up'){ // 上移
      //   if(index == 0) {
      //     return
      //   }
      //   tableData = this.swapItems(tableData, index, index - 1)
      // }else if(buttonId === 'down'){ // 下移
      //   if(index === tableData.length -1) {
      //     return
      //   }
      //   tableData = this.swapItems(tableData, index, index + 1)
      // }
      // tableData.forEach((item,index) => {
      //   item['sort'] = (index+1)
      // })
      // console.info(tableData)
    },
    isTreeCmp () {
      // console.log('-------isTreeCmp-----'+this.config.type, this.config)
      return this.config.type === 4;
    },
    isTreeGridCmp () {
      // console.log('-------isTreeGridCmp-----'+this.config.type, this.config)
      return this.config.type === 2;
    },
    // 选人回调函数
    memberCallBack () {
      if (this.selectMemberModels.selectList.length == 0) {
        this.util.warn('请至少选择一个用户！');
        return false;
      }
      this.selectMemberModels.isShow = false;
      var vm = this;
      if (this.selectMemberModels.form && this.selectMemberModels.form.widgetType === 'select-user-multi') {
        // 判断是否批量授权用户
        if (this.selectMemberModels.form.columnName === 'user-auth') {
          let attr = JSON.parse(this.selectMemberModels.form.attr);
          let callbackType = attr.callbackType;
          if (callbackType === 'auth') {
            this.util.mask('正在保存...');
            let mappings = attr.mappings;
            let foreignKey = attr.foreignKey;
            let rows = this.getSelectedData();
            let businessKeys = [];
            let data = [];
            rows.forEach(row => {
              businessKeys.push(row['ID_'] || row['id']);
            });
            console.log('-----------------', rows, this.selectMemberModels.selectList, attr);
            this.selectMemberModels.selectList.forEach(element => {
              element.USER_UID_ = element.id;
              element.USER_NAME_ = element.userName;
              rows.forEach(row => {
                let r = {};
                // 给每个字段赋值
                mappings.forEach(mapping => {
                  let srcData = mapping.srcType === 'userData' ? element : row;
                  r[mapping.desColumn] = srcData[mapping.srcColumn];
                });
                data.push(r);
              });
            });
            console.log('------memberCallBack-------', businessKeys, data);
            if (data != null && data.length > 0) {
              let params = {foreignKey: foreignKey, desTableName: attr.tableName, businessKeys: businessKeys, data: data};
              this.util.restPost('/api_v1/form/select/batch/auth', params, res => {
                this.util.success('授权成功！');
                this.util.unmask();
              }, e => {
                this.util.warn(e);
              });
            }
          }
        }
      }
    }, // 选角色回调函数
    selectRoleCallBack () {
      let vm = this;
      if (this.selectRoleModels.selectList.length == 0) {
        this.util.warn('请至少选择一个角色！');
        return false;
      }
      this.selectRoleModels.isShow = false;
      if (this.selectRoleModels.form && this.selectRoleModels.form.widgetType === 'select-role-multi') {
        // 判断是否批量授权用户
        if (this.selectRoleModels.form.columnName === 'role-auth') {
          let attr = JSON.parse(this.selectRoleModels.form.attr);
          let callbackType = attr.callbackType;
          if (callbackType === 'auth') {
            this.util.mask('正在保存...');
            let mappings = attr.mappings;
            let foreignKey = attr.foreignKey;
            let rows = this.getSelectedData();
            let businessKeys = [];
            let data = [];
            rows.forEach(row => {
              businessKeys.push(row['ID_'] || row['id']);
            });
            console.log('-----------------', rows, this.selectRoleModels.selectList, attr);
            this.selectRoleModels.selectList.forEach(element => {
              element.ROLE_UID_ = element.id;
              element.ROLE_NAME_ = element.roleName;
              rows.forEach(row => {
                let r = {};
                // 给每个字段赋值
                mappings.forEach(mapping => {
                  let srcData = mapping.srcType === 'roleData' ? element : row;
                  r[mapping.desColumn] = srcData[mapping.srcColumn];
                });
                data.push(r);
              });
            });
            console.log('------memberCallBack-------', businessKeys, data);
            if (data != null && data.length > 0) {
              let params = {foreignKey: foreignKey, desTableName: attr.tableName, businessKeys: businessKeys, data: data};
              this.util.restPost('/api_v1/form/select/batch/auth', params, res => {
                this.util.success('授权成功！');
                this.util.unmask();
              }, e => {
                this.util.warn(e);
              });
            }
          }
        }
      }
    },
    toFixed (num) {
      let m;
      try {
        m = num.toString().split('.')[1].length;
      } catch (e) {
        m = 0;
      }
      var times = Math.pow(10, m);
      var des = 0;
      if (num > 0) {
        des = num * times + 0.5;
      } else {
        des = num * times - 0.5;
      }
      des = parseInt(des, 10) / times;
      return des + '';
    },
    rowClick (item) {
      // console.log('-------rowClick---------', item)
      this.$emit('handlerRowClick', item);
      // this.selectedData = [item]
      // if(this.selection.indexOf(item)<0){
      //   this.selection.push(item);
      // }
      // 判断是否是树
      if (this.config.type == 4) {
        if (this.singleSelect || !this.multipleSelect) {
          // 只有有checkBox选择框的才能够调用函数
          if (this.multipleSelect || this.showCheckBox) {
            this.$refs['jr-table'].setCheckedNodes(item);
          }
          // this.selection = [item]
          this.handlerSelectionChange([item]);
        }
      } else {
        if (this.singleSelect || !this.showCheckBox) {
          this.$refs['jr-table'].setCurrentRow(item);
          // this.selection = [item]
          this.handlerSelectionChange([item]);
        } else {
          this.$refs['jr-table'].toggleRowSelection(item);
          // this.handlerSelectionChange([item])
        }
      }
      // console.info(this.selection)
    },
    handleDelete (index, row) { // 删除的时候执行
      let column = this.columnsMap['delete'];
      if(column && this.validUtil.isNotNull(column.disabledCondition)){
        let disabled = this.computeDisabledConditionConfig(column,row);
        // console.log('----disabled----',disabled);
        if(disabled){
          this.util.warn("对不起，您没有权限!");
          return;
        }
      }
      let _this = this;
      this.util.confirm('确认要删除吗？', '提示', () => {
        // console.log(index, row);
        let id = row['ID_'];
        // console.info(this.config)
        let tableName = _this.config.tableName;
        // console.log('------handleDelete------',this.config)
        let params = {
          sqlTableName: tableName,
          tableName: tableName,
          businessKey: id,
          formKey: _this.config.formKey,
          formInfoId: _this.config.id,
          mainFormDataMap: row
        };
        // console.log('------handleDelete---22---',params)
        // 判断是否有子表
        if (_this.config.formColumns) {
          // console.log('------handleDelete---1---',_this.config.formColumns)
          let subForms = [];
          _this.config.formColumns.forEach(column => {
            // console.log('------handleDelete---22---',this.config)
            if (column.widgetType && column.widgetType === 'sub-form') {
              if (this.validUtil.isNotNull(column.config.tableName) && this.validUtil.isNotNull(column.config.subFormForeignKey) && column.config.tableName !== '无') {
                subForms.push({
                  subFormTable: column.config.tableName,
                  subFormForeignKey: column.config.subFormForeignKey
                });
              }
            }
          });
          // console.log('------handleDelete---3---',this.config)
          if (subForms.length > 0) {
            params.subFormData = JSON.stringify(subForms);
          }
        }
        // console.log('------handleDelete---11---',this.config)
        deleteDataV2(params).then(res => {
          _this.util.success('删除成功！');
          _this.loadData();

          // 判断是否刷新级联页面中的上级页面
          let flag = false;
          if (_this.config.events) {
            _this.config.events.find(event => {
              if (event.type === '19') {
                flag = true;
                return true;
              }
            });
            // console.log('------deleteDataV2------',flag,_this.config.parent)
            if (flag) {
              _this.loadParentData();
            }
          }
        });
        // let entity = formUtil.getEntity(this.config.entity)
        // let deleteSql = ''
        // if (entity) {
        //   if (entity.children) {
        //     entity.children.forEach(child => {
        //       deleteSql += 'delete from ' + child.tableName + ' where ' + child.foreignKey + '= \'' + id + '\';'
        //     })
        //   }
        //   deleteSql += 'delete from ' + entity.tableName + ' where ID_= \'' + id + '\';'
        //   // console.info('deleteSql-----------'+deleteSql)
        //   deleteData({sql: deleteSql}).then(res => {
        //     _this.util.success('删除成功！')
        //     _this.loadData()
        //   })
        // }
      });
    },
    deepBackFill (data, backFillMap) { // getSelectedData中递归回填数据
      // console.log('------deepBackFill-------', data, backFillMap)
      data = data.map(item => {
        let newItem = {};
        for (let rule in backFillMap) {
          newItem[rule] = item[backFillMap[rule]];
        }
        if (newItem.children && newItem.children.length > 0) {
          newItem.children = this.deepBackFill(newItem.children, backFillMap);
        }
        // console.log(newItem, 'newItem')
        return newItem;
      });
      return data;
    },
    getSelectedData (flag) { // 获取选中行,flag为undefined的时候获取回填规则的数据，如果flag=0表示获取原数据
      if (this.gridData === undefined || this.gridData.length === 0) {
        return [];
      }

      let selectedData = this.selectedData && this.selectedData.length > 0 ? this.selectedData : this.selection;
      // console.log(flag+'---------getSelectedData----'+this.config.title+'----',this.selectedData, this.selection,selectedData)
      // 判断是否单选模式
      if (selectedData === null || selectedData.length == 0) {

      }
      // console.info('-----backfillRule----'+this.config.backfillRule);
      // 判断是否有回填规则
      if (flag == undefined && this.config.backFillMap) {
        selectedData = this.deepBackFill(selectedData, this.config.backFillMap);
      }
      // console.log('-----------selectedData-----------',selectedData)
      return selectedData;
    },
    getSelectedTreeData (flag) { // 获取选中的数据不包含子节点，只包含根节点以下数据, 主要用于明细表选择弹框
      let selectedData = this.getSelectedData(flag);
      if (selectedData) {
        let selectedMap = {};
        // 保存已选中的数据
        selectedData.forEach(item => {
          selectedMap[item['ID_'] || item['id']] = true;
        });
        // 只留下根节点下的第一层
        selectedData = selectedData.filter(item => {
          let key = item['parentId'];
          if (key && key === this.config.rootId) {
            return true;
          }
          return false;
        });
        // let data = this.config.tableData || this.gridData // 树结构是gridData
        // console.log('-------getSelectedTreeData----',selectedData, selectedMap)
        let srcData = this._deepTreeData(selectedData, selectedMap);
        return srcData;
      }
      return selectedData;
    },
    handlerOpenDialogConfirm: async function () { // openDialog弹框确定触发
      // 判断是否执行拷贝
      if (this.openDialogConfig.column && this.openDialogConfig.column.attr === 'copy') {
        let data = this.$refs['open-dialog'].getGridData(1);
        let selectedData = this.$refs['open-dialog'].getSelectedData(this.openDialogConfig.srcLevel || 1, 0);// 选中行

        let selectedMap = {};
        if (selectedData && selectedData != null) {
          selectedData.forEach(item => {
            selectedMap[item['ID_']] = true;
          });
        }
        // console.log('-------handlerOpenDialogConfirm--------',data,selectedData,this.$refs['open-dialog'])
        let extraParams;
        if (this.$refs['open-dialog'] && this.$refs['open-dialog'].getExtraParams) {
          extraParams = await this.$refs['open-dialog'].getExtraParams();
          // console.log('-----extraParams------',extraParams)
        }

        // console.log(data, selectedData)
        // 递归组装数据

        let srcData = [];
        if (this.isTreeGridCmp()) {
          srcData = this._deepTreeData(data, selectedMap);
        } else {
          srcData = selectedData;
        }

        if (srcData.length === 0) {
          this.warn('请选择数据源');
          return;
        }
        // console.log('-----最终计算结果-------', srcData)
        let srcFormKey = this.openDialogConfig.srcFormKey;
        let desFormKey = this.openDialogConfig.desFormKey;
        let desParams = this.openDialogConfig.desQueryParams;
        // console.log('-----desParams-------',desParams)
        // 判断是否删除旧的数据
        let ifDelete = this.openDialogConfig.ifDelete;
        // 选中的目标树主键
        let desId = '';
        let desSelectedData = this.getSelectedData(0);
        if (!ifDelete && desSelectedData && desSelectedData.length > 0) {
          desId = this.getSelectedData()[0]['ID_'];
        }
        // 判断是否带有过滤参数
        let desQueryParams = [];
        let queryParam = this.queryParams;
        // console.log('-------queryParam------',this.queryParams)
        if (queryParam) {
          // 把url传参或者父组件传参传递到后台
          for (let key in queryParam) {
            desQueryParams.push({'key': key, 'value': queryParam[key]});
          }
        }

        if (extraParams) {
          if (desParams === undefined) {
            desParams = {};
          }
          desParams = Object.assign(desParams, extraParams);
        }

        let desParentId = null;
        if (this.parentSelectedRow != null) {
          desParentId = this.parentSelectedRow.id || this.parentSelectedRow.ID_;
        }
        let desRootId = this.config.rootId;
        // console.log('------------', desParams, desQueryParams, desParentId, desRootId, desId)
        let desFormInfoId = this.config.id;
        // console.log(srcFormKey, desFormKey, desParentId, desQueryParams, srcData)
        let params = {srcFormKey, srcData, desFormKey, desFormInfoId, desRootId, desId, desParentId, desParams, desQueryParams, delete: ifDelete};
        // console.log('-------params-------',params)
        // return
        // 判断是否是树表单
        let sessionProj=this.sessionUtil.getProjInfo(this);
        if (sessionProj) {
          params.sessionProj = {
            projCode: sessionProj.PROJ_CODE_,
            projId: sessionProj.PROJ_ID_,
            projIdLable: sessionProj.PROJ_ID_LABEL_,
            projName: sessionProj.PROJ_NAME_,
            projUid: sessionProj.PROJ_UID_,
            projUidLable: sessionProj.PROJ_UID_LABEL_
          };
        }
        params.type = this.isTreeGridCmp() ? 0 : 1;
        copyTreeData(params, this).then(res => {
          this.loadData();
          this.openDialogVisible = false;
          // this.cascade = false
        });
      }
    },
    _deepTreeData (data, selectedMap) {
      let resultArr = [];
      if (data && data != null && data.length > 0) {
        // 组装选中的数据
        data.forEach(item => {
          let key = item['ID_'] || item['id'];
          if (selectedMap[key]) {
            // 判断是否有子节点
            let newItem = { ...item };
            newItem.children = this._deepTreeData(newItem.children, selectedMap);
            if (newItem.children.length === 0) {
              // delete newItem.children
            }
            resultArr.push(newItem);
          }
        });
      }
      return resultArr;
    },
    handlerSelectionChange (val) {
      // 如果是树获取所有选中行，包括子节点和上级节点
      if (this.config.type === 4 && (this.multipleSelect || this.showCheckBox)) {
        val = this.$refs['jr-table'].getCheckedNodes(false, true);
      }
      // 去重复
      /* let x = new Set(val);
      val = [...x]; */
      // 判断是否需要记录选中
      let ifSaveSelected = false;
      if (val && val[0]) {
        if (val[0]['ID_']) {
          // 取消记忆功能
          // ifSaveSelected = true
        }
      }
      // 判断如果是树，是列表或树表则做选中记忆
      if ((this.multipleSelect || this.showCheckBox) && ifSaveSelected && this.config.type !== 4) {
        // 对比val和旧的选中找出新增或者移除的
        let newData = [];
        let deleteData = [];
        let x = {};
        val = val.filter(item => {
          let key = item['ID_'] || item['id'];

          if (x[key]) {
            return false;
          } else {
            x[key] = item;
            return true;
          }
        });
        // this.$refs['jr-table'].toggleRowSelection(val)
        // 判断是否是tree
        if (this.selection && this.selection.length > 0) {
          this.selection.forEach((item, index) => {
            let find = val.find(s => {
              return s['ID_'] === item['ID_'];
            });
            if (find) {

            } else {
              deleteData.push(item);
            }
          });
          val.forEach(item => {
            let find = this.selection.find(s => {
              return s['ID_'] === item['ID_'];
            });
            if (find) {

            } else {
              newData.push(item);
            }
          });
        } else {
          val.forEach(item => {
            let find = this.selectedData.find(s => {
              return s['ID_'] === item['ID_'];
            });
            if (find) {

            } else {
              newData.push(item);
            }
          });
        }
        if (this.selectedData === undefined) {
          this.selectedData = [];
        } else {
          this.selectedData = this.selectedData.filter(item => {
            let find = deleteData.find(s => {
              return s['ID_'] === item['ID_'];
            });
            if (find) {
              return false;
            } else {
              return true;
            }
          });
        }
        this.selectedData = this.selectedData.concat(newData);
      }
      this.selection = val;
      // console.log('-------handlerSelectionChange----' + this.config.title + '--end---', this.selection, this.selectedData)
    },
    handlerSelectionAutoSet () { // 切换页面，或者pageSize变化时打勾之前选择
      if (this.gridData === undefined || this.gridData.length === 0) {
        this.selection = [];
      } else {
        // 判断如果是树，是列表或树表则做选中记忆
        if (this.config.type !== 4) {
          let checkedData = [];
          this.handlerDeepSetChecked(this.gridData, checkedData);
          if (checkedData) {
            this.$nextTick(() => {
              checkedData.forEach(row => {
                this.$refs['jr-table'].toggleRowSelection(row);
              });
            });
          } else {
            // this.$refs.multipleTable.clearSelection();
          }
        }
      }
      // console.log('------handlerSelectionAutoSet---' + this.config.title + '-----', this.selection, this.selectedData)
    },
    handleEdit (index, row) { // 点击编辑按钮
      let column = this.columnsMap['edit'];
      if(column && this.validUtil.isNotNull(column.disabledCondition)){
        let disabled = this.computeDisabledConditionConfig(column,row);
        // console.log('----disabled----',disabled);
        if(disabled){
          this.util.warn("对不起，您没有权限!");
          return;
        }
      }

      this.formConfig.businessKey = row['ID_'];
      // this.$router.push({params: {}})
      // 判断form-view中的路由qeury是否有值
      let routeQuery = this.config.parent.routeQuery;
      // console.info(routeQuery)
      // console.info(this.formConfig.initValues)
      if (routeQuery != undefined && routeQuery != null) {
        if (this.formConfig.initValues === undefined) {
          this.formConfig.initValues = routeQuery;
        } else {
          if (this.formConfig.initValues === undefined || this.formConfig.initValues === null) {
            this.formConfig.initValues = {};
          }
          for (let key in routeQuery) {
            this.formConfig.initValues[key] = routeQuery[key];
          }
          // this.formConfig.initValues = this.formConfig.initValues.concat(routeQuery);
        }
      }
      delete this.$route.params.formKey;
      if(this.editButtonColumn != null){
        this.handleRowButtonClick (this.editButtonColumn, index, row);
      }else{
        this.formDialogVisible = true;
      }
    },
    handlerTopButtonClick (button) { // queryForm页面点击topButton，切实弹框触发
      if (button.attr && button.attr === 'copy') {
        let selectedData = this.getSelectedData(0);
        // console.log('---------handlerTopButtonClick----------copy---------'+selectedData.length,selectedData)
        // 不是树表才会弹框
        if (selectedData.length !== 1 && this.isTreeGridCmp()) {
          this.warn('您没有选择数据，将拷贝到根节点下');
        }
      }
      // console.log('------handlerTopButtonClick-------', button)
      // 树组件按钮再右上角topButton时触发
      if (button.columnName === 'edit' || button.columnName === 'delete') {
        let selectedData = this.getSelectedData(0);
        if (selectedData.length !== 1) {
          // 请选择一行数据
          this.warn('请选择一行数据');
          return;
        }
        let selectedTreeNode = this.$refs['jr-table'].getNode(selectedData[0].id);

        if (button.columnName === 'edit') {
          this.handleEdit(selectedTreeNode, selectedData[0]);
        } else if (button.columnName === 'delete') {
          this.handleDelete(undefined, selectedTreeNode, selectedData[0]);
        }
        return;
      } else if (button.widgetType === 'import') {
        this.selectExcelVisible = true;
        this.excelList = button.data;
        return;
      }
      this.handleRowButtonClick(button, 0);
    },
    handleRowButtonClick (column, index, row) { // 列表中按钮
      // console.log('-------handleRowButtonClick-------', column, row)
      // 只读点击无效
      /* if (this.readOnly) {
        return
      } */
      if (column.events) {
        eval(column.events);
      }
      // 判断是否顶部工具栏
      if (!row && column.javaType && column.javaType === 'TopButton') {
        let openParamsObj = typeof column.openParams === 'string' ? JSON.parse(column.openParams) : column.openParams;
        if (openParamsObj && openParamsObj['singleSelect'] != undefined && openParamsObj['singleSelect']) {
          let data = this.getSelectedData();
          if (data.length != 1) {
            this.util.warn('请选择一行数据!');
            return;
          } else {
            row = data[0];
          }
        }
      }
      // console.log(column.openType + '--------1-------' + column.openUrl)
      if (column.openType && column.openUrl) {
        if (!row) {
          row = {};
        }
        let openParams = column.openParams;
        if (this.validUtil.isNull(openParams)) {
          openParams = '{}';
        }
        // console.info('openParams--1--'+openParams)
        if (openParams) {
          for (let key in row) {
            if (openParams.indexOf('{' + key + '}') > -1) {
              let value = row[key] ? row[key] : '';
              openParams = openParams.replace(new RegExp('{' + key + '}', 'gm'), value);
            }
          }
          // 判断是否还有参数不存在无法体会
          if (openParams.indexOf('{') > -1 && openParams.indexOf('}') > -1) {
            let keys = openParams.match(/\"\{(.*?)\}\"/gi); // 匹配所有类似{}的变量
            if (keys) {
              keys.forEach(key => {
                let columnName = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
                // console.info(key + '--------'+ columnName)
                let queryParams = {};
                if (this.queryParams) {
                  queryParams = this.queryParams;
                }
                // 如果是级联页面，则把上层数据也传入
                if (this.parentSelectedRow) {
                  // 一般情况不把父级的ID传递，父级id回根据左右关联自动转配，如果需要了则另外定义参数比如PARENT_ID_
                  delete this.parentSelectedRow['ID_'];
                  queryParams = Object.assign(this.parentSelectedRow, queryParams);
                }
                let sessionProj = null;
                if (window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id)) {
                  sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id));
                } else if (this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id]) {
                  sessionProj = this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id].data;
                  // console.log('------mainData-------', mainData, sessionProj)
                }
                if (sessionProj) {
                  if (this.validUtil.isNull(queryParams['PROJ_UID_'])) {
                    queryParams['PROJ_UID_'] = sessionProj.PROJ_UID_;
                  }
                  if (this.validUtil.isNull(queryParams['PROJ_NAME_'])) {
                    queryParams['PROJ_NAME_'] = sessionProj.PROJ_NAME_;
                  }
                  if (this.validUtil.isNull(queryParams['session-proj-uid'])) {
                    queryParams['session-proj-uid'] = sessionProj.PROJ_NAME_;
                  }
                }
                // 试着替换查询参数 queryParams
                if (queryParams[columnName]) {
                  openParams = openParams.replace(new RegExp(key, 'gm'), '"' + queryParams[columnName] + '"');
                } else {
                  openParams = openParams.replace(new RegExp(key, 'gm'), '""');
                }
              });
            }
          }
        }

        // console.info('openParams--2--'+openParams)

        openParams = typeof openParams === 'string' ? JSON.parse(openParams) : openParams;
        if (openParams && openParams.title) {
          this.openDialogTitle = openParams.title;
        } else {
          this.openDialogTitle = this.config.title;
        }
        // console.log('---------------')
        if (column.openType === 3) { // 打开新标签
          let openUrl = column.openUrl;
          if (openUrl) {
            let baseUrl = this.util.getBaseUrl();
            let access_token = this.sessionUtil.getAccessToken();
            let params = { ...row, baseUrl, access_token };
            // console.log(params)
            for (let key in params) {
              // console.log('{'+key+'}','---',openUrl.indexOf('{'+key+'}'))
              if (openUrl.indexOf('{' + key + '}') > -1) {
                openUrl = openUrl.replace('{' + key + '}', params[key]);
              }
              // console.log(openUrl)
            }
            window.open(openUrl);
          }
        } else if (column.openType === 2) { // tab打开
          this.openByName(column.openUrl, openParams);
          // this.$router.push({
          //   name: 'form-view',
          //   params: {
          //     formKey:'project-info',
          //     title:'项目信息'
          //   }
          // })
        } else if (column.openType === 1 || column.openType === 4) {
          // console.info(this.$route)
          // console.info(this.$router)
          // console.log('--------openParams----------'+openParams)

          // 根据配置设置弹窗的宽高
          this.openDialogWidth = column.openWidth || '';
          this.openDialogHeight = column.openHeight || '';

          this.openDialogVueName = column.openUrl; // eg: 'form-edit'
          let params = null;
          if (this.openDialogVueName === 'form-query' || this.openDialogVueName === 'form-view') {
            // 说明是查询列表
            this.showOpenDialogTitle = false;
            params = {};
            openParams = typeof openParams === 'string' ? JSON.parse(openParams) : openParams;
            params = Object.assign(params, openParams);
            params.selectFormKey = openParams.formKey;
            // 给列表传递查询参数
            params.queryParams = openParams.queryParams;
            params.openConfig = {};
            /* // console.log('----------',openParams)
            if(openParams.assignMultipleSelect){
              params.assignMultipleSelect = openParams.assignMultipleSelect
            } */
          } else {
            this.showOpenDialogTitle = true;
            params = {
              openConfig: typeof openParams === 'string' ? JSON.parse(openParams) : openParams
            };
          }

          console.log(column.openUrl, column, '-------------', this.openDialogWidth, this.openDialogHeight);

          let route = this.getRouteConfigByName(column.openUrl);
          // console.info(route)
          // 因为是表单所以通过这种方式传参
          params.openConfig.parent = this;
          params.openConfig.openDialogTitle = params.openConfig.title || this.config.title;

          // console.log(this.openDialogWidth,this.openDialogHeight,params.openConfig.openDialogTitle,params.openConfig.title,'----------',params)

          this.openDialogConfig = {
            route, params
          };
          // 判断是否执行的是拷贝
          if (column.attr && column.attr === 'copy' && (openParams.desFormKey || params.openConfig.desFormKey)) {
            this.openDialogConfirmVisible = true;
            // this.cascade = true // 设置是级联，这样就可以根据配置的窗口大小打开
            // params.desFormKey = openParams.desFormKey//
            // 设置源视图的层级，比如级联时需要指明，默认是1
            this.openDialogConfig.srcLevel = openParams.srcLevel || params.openConfig.srcLevel;
            this.openDialogConfig.desFormKey = openParams.desFormKey || params.openConfig.desFormKey;
            this.openDialogConfig.srcFormKey = openParams.formKey || params.openConfig.formKey;
            this.openDialogConfig.desQueryParams = openParams.desQueryParams || params.openConfig.desQueryParams;
            // this.openDialogConfig.ifDelete = !!(openParams.desQueryParams || params.openConfig.desQueryParams)
            this.openDialogConfig.ifDelete = openParams.delete === undefined ? false : openParams.delete;
            // console.log('-------openParams--------', openParams)
            this.openDialogConfig.column = column;
            // this.openDialogConfig.selectedData = this.getSelectedData()
          }
          // 父页面弹框
          if (column.openType === 4) {
            this.$emit('handlerOpenDialog', this.openDialogConfig);
          } else {
            this.openDialogVisible = true;
          }
          // console.log('---this.openDialogConfig------'+this.openDialogVisible,this.openDialogWidth,this.openDialogHeight,this.openDialogConfig)
        }
      } else {
        // 判断标签tag组件是否配置有的状态不能点击, 例如：发布,1;取消发布,2;已发布,5,0;
        if (column.widgetType && column.widgetType === 'tag') {
          let value = row[column.columnName];
          // console.log('----------', column, value)
          if (column.attr) {
            let tagArr = column.attr.split(';');
            for (let i = 0; i < tagArr.length; i++) {
              let tagItem = tagArr[i].split(',');
              // console.log('----------', tagItem, tagItem[0])
              if (tagItem && tagItem[0] === value && tagItem.length === 3) {
                // 发布,1;取消发布,2;已发布,5,0
                if (tagItem[2] === '0') {
                  // 表示不能点击
                  return;
                }
              }
            }
          }
        } else if (column.widgetType && column.widgetType === 'select-user-multi') {
          let data = this.getSelectedData();
          if (data == null || data.length === 0) {
            this.util.warn('请先选择数据!');
            return;
          }

          // 判断是否选人弹框授权，例如文档权限设置
          this.selectMemberModels.form = column;
          this.selectMemberModels.isShow = true;
          this.selectMemberModels.selectList = [];
          this.selectMemberModels.radioSelectFlags = false;
          return;
        } else if (column.widgetType && column.widgetType === 'select-role-multi') {
          let data = this.getSelectedData();
          if (data == null || data.length === 0) {
            this.util.warn('请先选择数据!');
            return;
          }

          // 判断是否选人弹框授权，例如文档权限设置
          this.selectRoleModels.form = column;
          this.selectRoleModels.isShow = true;
          this.selectRoleModels.selectList = [];
          this.selectRoleModels.radioSelectFlags = false;
          return;
        }
        // 判断是否按钮触发调用
        if (column.sourceType === 'api' && column.sourceAttr) {
          let idArr = [];
          if (!row) {
            row = {};
            // 说明是顶部工具栏触发，说明是多选
            let selectedData = this.getSelectedData();
            if (selectedData && selectedData.length > 0) {
              selectedData.forEach(item => {
                if (item['ID_'] || item['id']) {
                  idArr.push(item['ID_'] || item['id']);
                }
              });
              row['ids'] = idArr.join(',');
            } else {
              this.warn('请选择数据!');
              return;
            }
          }
          let _this = this;
          let apiConfigArr = column.apiConfig;
          if (apiConfigArr) {
            let message = '';
            if (_this.validUtil.isNotNull(column.attr)) {
              debugger;
              // 先判断是否市json
              try {
                let strObj = JSON.parse(column.attr);
                message = strObj.message;
              } catch (error) {
                message = '是否确认此操作?';
              }
            } else {
              message = '是否确认此操作?';
            }
            this.$confirm(message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              let promiseArr = [];
              // apiConfigArr.forEach(apiConfig => {
              for (let i = 0; i < apiConfigArr.length; i++) {
                let apiConfig = apiConfigArr[i];
                let params = {};
                if (apiConfig.children) {
                  apiConfig.children.forEach(child => {
                    let key = null;
                    for (let field in row) {
                      if (child.value === '{' + field + '}') {
                        key = field;
                      }
                    }
                    if (key) {
                      params[child.code] = row[key];
                    } else {
                      params[child.code] = child.value;
                    }
                  });
                }
                // 获取sql中需要传入后台的参数
                if (apiConfig.runsql) {
                  let runsql = apiConfig.runsql;
                  for (let field in row) {
                    let key = null;
                    if (runsql.indexOf('{' + field + '}') > -1) {
                      key = field;
                    }
                    if (key && row[key]) {
                      params[key] = row[key];
                    }
                  }
                }
                // 判断是否接口
                if (apiConfig.runtype === 'Interface') {
                  params['_url'] = apiConfig.runsql;
                  for (let key in row) {
                    if (params['_url'].indexOf('{' + key + '}') > -1) {
                      params['_url'].replace('{' + key + '}', row[key]);
                    }
                  }
                }
                if (row['ids']) {
                  params['ids'] = row['ids'];
                } else {
                  params['businessKey'] = row['ID_'] || row['id'];
                }

                params['formKey'] = this.config.formKey;

                // 判断是否有条件
                let condition = apiConfig.condition;
                if (this.validUtil.isNotNull(condition)) {
                  this.gridColumns.forEach(c => {
                    if (condition.indexOf(c.columnName) > -1) {
                      let value = row[c.columnName];
                      if (c.javaType && c.javaType === 'String') {
                        value = '"' + value + '"';
                      }
                      condition = condition.replace(new RegExp('{' + c.columnName + '}', 'gm'), value);
                    }
                  });
                  var flag = true;
                  var expression = 'flag = (' + condition + ')';
                  // console.log('-----expression-----' + expression)
                  eval(expression);
                  if (!flag) {
                    continue;
                  }
                }

                // 调用获取数据
                let p = getDataByApi(apiConfig.id, params);
                promiseArr.push(p);
              }

              _this.util.mask('正在执行...');
              Promise.all(promiseArr).then(() => {
                _this.loadData();
                _this.util.unmask();
                _this.util.success('执行成功!');
              }).catch((error) => {
                _this.util.error(error.errorMsg);
                _this.util.unmask();
              });
            });
          }
        }
      }
      // console.info('22---------')
    },
    getRouteConfigByName (name) {
      // console.info(name)
      if (this.$router.options.routes) {
        let data = [];
        for (let i = 0; i < this.$router.options.routes.length; i++) {
          let item = this.$router.options.routes[i];
          if (item.name === name) {
            data.push(item);
            break;
          } else {
            if (item.children && item.children.length > 0) {
              for (let j = 0; j < item.children.length; j++) {
                let child = item.children[j];
                if (child.name === name) {
                  data.push(child);
                  break;
                }
              }
            }
          }
        }
        if (data) {
          if (data.length > 0) {
            return data[0];
          }
          return data;
        }
      }
      return null;
    },
    confirmSelect (row, column, event) {
      this.$emit('confirmSelect', this.deepBackFill([row], this.config.backFillMap));
    },
    handlerDeepSetChecked (data, checkedData) { // 递归勾选之前选中的数据
      // console.log('---------handlerDeepSetChecked--------', data, this.selectedData)
      if ((this.multipleSelect || this.showCheckbox) && this.selectedData && this.selectedData.length > 0) {
        data.forEach(item => {
          let find = this.selectedData.find(temp => {
            if (temp['ID_'] === item['ID_']) {
              return true;
            }
          });
          // console.log(item['INSPECT_ITEM_'] + '--------find---------', item, find, this.selection)
          if (find) {
            // this.$refs['jr-table'].toggleRowSelection(item, true)
            checkedData.push(item);
          }
          if (item.children) {
            this.handlerDeepSetChecked(item.children, checkedData);
          }
        });
      }
    },
    getSummaries (param) {
      // console.info('--------getSummaries-------', param)
      const { columns, data } = param;
      const sums = [];
      let _this = this;
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        // console.info(column.columnName+'-----------'+column.property)
        // console.info(_this.summaryColumns)
        // console.info(column)
        let property = column.property ? column.property : column.columnName;
        let columnConfig = _this.summaryColumns[property];
        if (columnConfig) {
          let title = columnConfig.title;
          // console.info(columnConfig)
          const values = data.map(item => {
            // console.info(property+'-----'+JSON.stringify(item))
            let val = item[property];
            // console.info('1--------'+val);
            val = Number(val);
            // console.info('2--------'+val);
            return val;
          });
          // console.info(values)
          if (!values.every(value => isNaN(value))) {
            // console.info('---------')
            let result = values.reduce((prev, curr) => {
              // console.info(prev+'--------'+curr)
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.util.numAdd(prev, value);
              } else {
                return prev;
              }
            }, 0);
            // console.info('result---'+result)
            // 解决合计精度丢失问题
            result = result === undefined ? 0 : this.toFixed(result);
            sums[index] = result;
            if (columnConfig.widgetType === 'number-permil') {
              sums[index] = this.util.numToPermil(result);
            }
            _this.summaryData[title] = result;
            // sums[index] += ' 元';
          } else {
            sums[index] = '';
            _this.summaryData[title] = 0;
          }
        } else {
          sums[index] = '';
        }
      });
      // console.info(_this.summaryData,sums)
      return sums;
    },
    computeShowConditionConfig (column, row) { // 计算显示隐藏规则
      // console.log('------computeShowConditionConfig-----',column, row)
      // 修改和删除按钮有可能是undefined
      if(!column){
        return true;
      }
      let rule = column.showCondition;
      if(this.validUtil.isNull(rule)){
        return true;
      }
      let _this = this;
      // console.log('---computeDisabledConditionConfig----',_this)
      let keys = rule.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let columnName = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let colName = _this.columnTitleMap[columnName];
          let col = _this.columnsMap[colName];
          if (col !== undefined && col !== null) {
            let val = this.getValByColumnTitle(columnName, col, row);
            rule = rule.replace(key, val);
          } else {
            // 也许是系统常量
            if (columnName === '审批状态') {
              let val = '"' + row['PROC_STATUS_'] + '"';
              rule = rule.replace(key, val);
            }
          }
        });
      } else {
        // 说明已经全部过滤完了
      }

      keys = rule.match(/\{(.*?)\}/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let colName = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let col = _this.columnsMap[colName];
          if (col !== undefined && col !== null) {
            let columnName = col.title;
            let val = this.getValByColumnTitle(columnName, col, row);
            rule = rule.replace(key, val);
          } else {
            // 也许是系统常量
            let val = this.sessionUtil.getConstValue(this,colName);
            rule = rule.replace(key, val);
          }
        });
      }

      try {
        // 默认显示
        let flag = false;
        rule = 'flag = (' + rule + ')';
        eval(rule);
        // alert(("银行转帐" !== "银行转账"))
        // console.log('----------计算禁用显示---------'+flag,rule)
        if (flag) {
          // 设置警用
          return true;
        } else {
          return false;
        }
        this.$forceUpdate();
      } catch (e) {
        console.log('----------计算禁用显示----error-----', rule, e);
        return false;
      }
    },
    computeDisabledConditionConfig (column, row) { // 计算禁用规则
      let rule = column.disabledCondition;
      let _this = this;
      // console.log('---computeDisabledConditionConfig----',_this)
      let keys = rule.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let columnName = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let colName = _this.columnTitleMap[columnName];
          let col = _this.columnsMap[colName];
          if (col !== undefined && col !== null) {
            let val = this.getValByColumnTitle(columnName, col, row);
            rule = rule.replace(key, val);
          } else {
            // 也许是系统常量
            if (columnName === '审批状态') {
              let val = '"' + row['PROC_STATUS_'] + '"';
              rule = rule.replace(key, val);
            }
          }
        });
      } else {
        // 说明已经全部过滤完了
      }
      keys = rule.match(/\{(.*?)\}/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let colName = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let col = _this.columnsMap[colName];
          if (col !== undefined && col !== null) {
            let columnName = col.title;
            let val = this.getValByColumnTitle(columnName, col, row);
            rule = rule.replace(key, val);
          } else {
            // 也许是系统常量
            let val = this.sessionUtil.getConstValue(this,colName);
            rule = rule.replace(key, val);
          }
        });
      }
      try {
        // 默认显示
        let flag = false;
        rule = 'flag = (' + rule + ')';
        eval(rule);
        // alert(("银行转帐" !== "银行转账"))
        // console.log('----------计算禁用显示---------'+flag,rule)
        if (flag) {
          // 设置警用
          return true;
        } else {
          return false;
        }
        this.$forceUpdate();
      } catch (e) {
        console.log('----------计算禁用显示----error-----', rule, e);
        return false;
      }
    },
    getValByColumnTitle (srcColumnTitle, srcColumn, row) { // 根据字段名称获取val
      let _this = this;
      let srcColumnName = _this.columnTitleMap[srcColumnTitle];
      if (srcColumn == undefined || srcColumn == null) {
        srcColumn = _this.columnsMap[srcColumnName];
      }
      // console.info(srcColumnTitle+'-----getValByColumnTitle----'+srcColumnName)
      let val = null;
      if (srcColumn && srcColumnName) {
        // 说明是数据库字段
        if (srcColumn.widgetType === 'select-form' || srcColumn.widgetType === 'select-user' || srcColumn.widgetType === 'select-depart') {
          val = '"' + row[srcColumnName + 'LABEL_'] + '"';
          // console.info('---val----'+val)
        } else if (srcColumn.widgetType === 'select' || srcColumn.widgetType === 'select-dic' || srcColumn.widgetType === 'select-sql') {
          let options = srcColumn.options;
          // console.info(srcColumnTitle+'-----getValByColumnTitle--1--'+options)
          if (options) {
            let option = options.find(option => {
              return option.value === row[srcColumnName];
            });
            if (option) {
              val = '"' + option.value + '"';
            }
          }
        } else if (srcColumn.widgetType === 'select-date' || srcColumn.widgetType === 'select-time' || srcColumn.widgetType === 'select-date-time') {
          val = '"' + row[srcColumnName] + '"';
        } else {
          // console.log('----------22-----------',srcColumnName,srcColumn)
          if (srcColumn.javaType === 'String') {
            val = '"' + row[srcColumnName] + '"';
          } else {
            val = row[srcColumnName];
          }
        }
        // console.info(srcColumnTitle+'----'+srcColumn.javaType+'-----'+val)
        if (val == 'undefined' || val == '"undefined"' || val === undefined || val === null || val === '') {
          if (srcColumn.javaType === 'Integer' || srcColumn.javaType === 'Double' || srcColumn.javaType === 'Float') {
            val = 0;
          } else {
            val = '""';
          }
        }
      } else {
        // 判断是否系统常量
        val = '"' + this.sessionUtil.getConstValue(this, srcColumnTitle) + '"';
      }
      // console.info(srcColumnTitle+'---22222-----'+val)
      // console.info(key+'--'+(val == '"undefined"')+'--'+typeof val+'--'+val)
      // console.info(val.length+'--'+'undefined'.length)
      if (val == 'undefined' || val == '"undefined"' || val === undefined || val === null) {
        val = '""';
      }
      return val;
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/form/gridMixin.js